<template>
	<div class="lhygCompanyAddr" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-u97 Icon"></i>
			<span class="header_text">/ 灵活用工 / 用工地址</span>
		</div>
		<div class="companybox content_Box box-shadow m-t-15 p-l-10 p-r-10" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div class="row-box m-b-20">
				<div class="clear">
					<div class="row-info fl">
						<div class="fl title-key"><i class="zb zb-asterisk"></i>企业或门店简称</div>
						<div class="fl list-cont">
							<el-input placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="row-info fl">
						<div class="fl title-key"><i class="zb zb-asterisk"></i>所在商圈</div>
						<div class="fl list-cont">
							<el-input placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>
				<div class="clear">
					<div class="row-info fl">
						<div class="fl title-key"><i class="zb zb-asterisk"></i>上岗地址</div>
						<div class="fl list-cont">
							<el-input placeholder="请输入内容" v-model="mapPointName"></el-input>
						</div>
					</div>
					<div class="row-info fl">
						<div class="fl title-key"><i class="zb zb-asterisk"></i>坐标</div>
						<div class="fl list-cont">
							<el-input readonly placeholder="请输入内容" v-model="lnglat"></el-input>
						</div>
					</div>	
				</div>
				
				<div class="clear"></div>

			</div>
			 
			<template>
				<div class="map">
					<div class="row-info">
						<div class="fl title-key"> 搜索地址关键字 </div>
						<div class="fl list-cont"><div class="search-box"><el-input placeholder="请输入地址来直接查找相关位置" v-model="addressKeyword"></el-input></div></div>
					</div>	
					<div class="clear"></div>
				    <!-- <el-input v-model="addressKeyword" placeholder="请输入地址来直接查找相关位置"></el-input> -->
				    <!-- 给地图加点击事件getLocationPoint，点击地图获取位置相关的信息，经纬度啥的 -->
				    <!-- scroll-wheel-zoom：是否可以用鼠标滚轮控制地图缩放，zoom是视图比例 -->
				    <baidu-map class="bmView" :scroll-wheel-zoom="true" :center="location" :zoom="zoom" @click="getLocationPoint" @ready="handler" ak="l40B1mkg9tPquS6YXMINrQ4p9ObxrjWl" >
						<bm-view></bm-view>
						<bm-local-search :keyword="addressKeyword" :auto-viewport="true" style="display: none"></bm-local-search>
					</baidu-map>
				</div>
				
			</template>
		</div>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	import {
		publicData
	} from '../assets/js/data.js';
	let map = null,
		geoc = null;
	export default {
		name: 'lhygCompanyAddr',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小	
				mapPointName:'',  //  上岗地址
				addressComponents:'', //选定的详细地址
				lnglat:'', //坐标
				BMap:'', 
				location: {
				    lng: 116.404,
				    lat: 39.915
				},
				zoom: 12.8,
				addressKeyword: "",
				
			}
		},
		created() {
			 
		},
		mounted() {
			
			this.start();
		},
		methods: {
			start(){
				
			},
			handler ({BMap, map}) {
				this.BMap = BMap;
				console.log(BMap);
				console.log(map);
				map.addControl(new BMap.NavigationControl());    
				map.addControl(new BMap.ScaleControl());    
				map.addControl(new BMap.OverviewMapControl());
			     
			    
			},
			// window.addEventListener('touchmove', func, { 
			// 	passive: false ,
			// })
			getLocationPoint(e) {
				/* 创建地址解析器的实例 */
				let geoCoder = new BMap.Geocoder();
				/* 获取位置对应的坐标 */
				geoCoder.getPoint(this.addressKeyword, point => {
				    this.location.lng = point.lng;
				    this.location.lat = point.lat;
					this.lnglat = this.location.lng+','+this.location.lat;
				});
				/* 利用坐标获取地址的详细信息 */
				geoCoder.getLocation(e.point, res=>{
				      console.log(res);
					  this.addressComponents = res.addressComponents;
					  this.mapPointName = res.address;
				})
				
			},
			
			
		
		},
	}
</script>

<style scoped>
	.map {width: 80%;height: 500px;}
	.row-info {padding: 5px 0;}
	.title-key {width: 100px;}
	.list-cont{	width:300px;}
	.bmView {width: 100%; height:490px; padding-top: 10px;}
	.bmView>div{height:400px;border: 1px solid #CCCCCC;}
	
	
	
	
	
</style>



// WEBPACK FOOTER //
// src/components/LhygCompanyAddr.vue